import React, { useEffect, useMemo, useState } from 'react'
import { UserType, getUserType } from '../../api/auth-api'
import { AuthContext } from './auth-context'

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [userType, setUserType] = useState<UserType | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const response = await getUserType()
        setUserType(response.type)
      } catch (err) {
        console.error('Failed to fetch user type', err)
        setError('Failed to load application. Please try again later.')
      } finally {
        setIsLoading(false)
      }
    }

    void fetchUserType()
  }, [])

  const contextValue = useMemo(
    () => ({
      userType,
      isLoading,
      error,
    }),
    [userType, isLoading, error]
  )

  return <AuthContext value={contextValue}>{children}</AuthContext>
}
